import { ColorShade } from './color.helpers'

import { ThemeFormValues } from '../../services/theme-section-form'

export interface ColorForm {
  name: string
  path: string
  fg: ThemeFormValues
}

export interface ColorRenderer {
  name: string
  shades: ColorShade[]
}

export interface ColorOption {
  hex: string
  label: string
  value: string
}

export type ColorGroupOption = {
  label: string
  value?: any
  children?: ColorGroupOption[]
}

export const DEFAULT_THEME_TYPE = 'light'
export const MAIN_COLOR_SHADE = '500'
